// The brand-portal workspace lives at /portal/:brandSlug/* for ANY brand
// (rmn:true networks add the white-label login and Catalog > Brands). The
// old /rmn/:brandSlug/* family is shimmed onto it in router/default.tsx.
export const portalBasePath = (slug: string) => `/portal/${slug}`
